import { useQuery } from "@tanstack/react-query";
import api from "../../../api";
import urls from "../../../urls";
import type { Delivery } from "../../../utils/backend-types";

function useDeliveries(projectId: string) {
  const { isLoading, error, data } = useQuery({
    queryKey: ["deliveries", { projectId }],
    queryFn: () => getDeliveries(projectId)
  });

  return {
    isLoading: isLoading,
    error: error,
    deliveries: data || []
  };
}

async function getDeliveries(projectId: string) {
  const response = await api.get<Array<Delivery>>(
    urls.api.deliveries(projectId)
  );
  return response.data;
}

export { useDeliveries };
